import { TemplatePage } from './types';

const live_streaming_qa: TemplatePage = {
  header: {
    color: '#FBD1D5',
    icon: 'images/video-templates/qa.jpg',
    title: 'Q&A Screen Templates',
    title_meta: '20+ Free Live Stream Q&A Screen Templates',
    description_meta:
      'Introduce your Q&A session like a Pro with Wave.video’s easy-to-customize live stream Q&A screen' +
      ' templates.',
    description:
      'Design a professional Q&A screen at ease to introduce the beginning of the session. Wow your' +
      ' viewers with stylish and comprehensive visual elements that embellish your live streams.'
  },
  footer: {
    category: 'Live streaming Q&A screen templates',
    description:
      'With Wave.video’s collection of editable templates, you can be on top of the live streaming game' +
      ' even with no design skills. Create the complete set of necessary overlays to wow your viewers:' +
      ' thumbnails, intros, technical screens, countdowns, lower thirds, and any other overlays. Uncover' +
      ' the power of beautiful visuals that make people addicted to your content.'
  },
  content: [
    {
      type: 'templates',
      title: 'Live streaming Q&A screen templates',
      search: { name: 'LiveQA', tags: 'LiveQA' }
    },
    { type: 'calendar' }
  ]
};

export default live_streaming_qa;
